import React, { useContext, useEffect, useRef } from "react";
import styles from "./StorySvetlana.module.scss";
import stylesText from "../../components/Text/Text.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import Cover from '../../components/Cover';
import Figure from '../../components/Figure';
import StoryDate from '../../components/StoryDate';
import Footer from '../../components/Footer';
import MoreStory from '../../components/MoreStory';
import Invite from '../../components/Invite';
import StickyFiles from '../../components/StickyFiles';
import Conclusion from '../../components/Conclusion';
import FileCardProgress from '../../components/FileCardProgress';
import Quote from '../../components/Quote';
import Stars from '../../components/Stars';
import Test from '../../components/Test/Test';
import Comment from '../../components/Comment';
import Message from '../../components/Message';
import Photo from '../../components/Photo';
import ProgressBar from '../../components/ProgressBar';
import Parallax from '../../components/Parallax/Parallax';
const StorySvetlana = () => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);

  const refContruction = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 1);
    const wrap = refContruction.current;
    let options = {
      threshold: 0,
      rootMargin: '0% 0% 0% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          observer.unobserve(entry.target);
        }
      })
    }, options);
    observer.observe(wrap);

    return () => {
      observer.unobserve(wrap);
    }
  }, []);

  let figureBgArray = [
    'green-light-triangle.svg',
    'transparent-saw-svetlana.svg',
    'green-saw.svg'
  ];
  if (isMobile) {
    figureBgArray = [
      'green-light-triangle.svg',
      'green-saw-svetlana.svg',
      'yellow-saw-square.svg'
    ];
  }
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover}>
          <Cover img={'svetalana-img'} name={'Светлана Иващенко'} position={'Заместитель директора департамента региональных продаж по Москве и Московской области'} text={['Привет! Моя история — о поступательном карьерном росте. Я пришла в Р-Фарм в 2016 году на позицию территориального менеджера Московской области. ', 'А к 2022 году доросла до заместителя директора департамента продаж не только по области, но и по Москве.']}>
            <>
              <div className={styles.constructions} ref={refContruction}>
                <div className={styles.constructions__row}>
                  <div className={`${styles.construct} ${styles.construct_1}`}>
                    <Figure color={"pink"} form={'rect'}>
                      <div className={styles.construct__text}>за шесть лет </div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_2}`}>
                    <Figure bg={figureBgArray[0]} form={'circle'}>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_3}`}>
                    <Figure bg={figureBgArray[1]}>
                      <div className={styles.construct__text}>выросла</div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_4}`}>
                    <Figure bg={figureBgArray[2]} form={'circle'}>
                    </Figure>
                  </div>
                </div>
                <div className={styles.constructions__row}>
                  <div className={`${styles.construct} ${styles.construct_5}`}>
                    <Figure color={"green_light"} form={'circle'}>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_6}`}>
                    <Figure color={"green_light"} >
                      <div className={styles.construct__text}>до заместителя директора</div>
                    </Figure>
                  </div>
                </div>
              </div>
            </>
          </Cover>
        </div>

        <section data-stage='0' className={`${styles.stage} ${styles.stage_1}`}>
          <div className="container">
            <StoryDate date={'2016'} title={'Начало пути'} color={'green'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_1}`} data-animate={'fade-in-up'}>
              <p>
                В 2016 году я работала в другой фармацевтической компании в отделе продвижения. Уже тогда я хотела развиваться в продажах, но не получалось: вакансий в этой компании не было.
              </p>
            </div>
            <div className={styles.sticky} data-animate={'fade-in-up'}>
              <StickyFiles height='300vh'>
                <FileCardProgress
                  icon={'svetlana-icon-1'}
                  text={['У коммерческих отделов фармкомпаний есть особенность: отделы маленькие,\nиз 1–3 сотрудников, люди работают на своих должностях по многу лет, и новых сотрудников берут редко.', 'Обычно работа там идет размеренно, условно: сотрудники приходят в 9:00, занимаются предсказуемыми, рутинными задачами, уходят в 18:00.']}
                  img={'svetlana-photo-1'}
                />
                <FileCardProgress
                  icon={'svetlana-icon-2'}
                  text={['Я увидела вакансию территориального менеджера в Р‑Фарм, поняла, что это мой шанс, и решила откликнуться. Тут я могла бы работать не только с продажами как коммерческий менеджер, но еще и заниматься дистрибуцией.', 'В Р‑Фарм сотрудники часто сталкиваются с новыми задачами, решают их и еще пять других параллельно. Работа тут не размеренна, а скорее хаотична. И ее много.']}
                  img={['svetlana-photo-2', 'svetlana-photo-3']}
                  counter={[15, 622]}
                  desc={['Новых проектов в год', 'рабочих места в среднем создается\nв Р-Фарм каждый год']}
                  isProgress={true}

                />
              </StickyFiles>
            </div>
            <div className={`${styles.quote}`}>
              <Quote text={['Я не могу находиться в трясине, делать работу', 'размеренно и спокойно. Мне всегда нужны вызовы', 'и новые проекты. И в Р-Фарм я получила всё это:', 'коллектив оказался амбициозным, а работа —', 'активной.']} textMobile={['Я не могу находиться', ' в трясине, делать работу', ' размеренно и спокойно.', ' Мне всегда нужны вызовы', 'и новые проекты.', ' И в Р-Фарм я получила всё ', 'это: коллектив оказался', ' амбициозным, а работа —', 'активной.']} color={'green'} />
            </div>
          </div>
        </section>

        <section data-stage='1' className={`${styles.stage}`}>
          <div className="container">
            <StoryDate date={'2018'} title={'Наставничество —\nпуть к росту'} color={'green'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_2}`} data-animate={'fade-in-up'}>
              <p>
                До 2018 года я работала с больницами и медучреждениями по Московской области. В этой работе есть свои сложности: учреждения разбросаны по всей области и одному менеджеру тяжело. Нужно много ездить, помнить детали о каждом учреждении и со всеми поддерживать контакты.
              </p>
              <p>
                Поэтому в Р-Фарм решили взять ещё одного сотрудника, чтобы мы с ним поделили территорию. Так я стала старшим территориальным менеджером.
              </p>
            </div>
            <div className={styles.stars}>
              <Stars number={3} value={1} color={'green'} />
            </div>
            <div className={`${styles.test} ${styles.test_1}`}>
              <Test
                question={'Для нового сотрудника я стала наставником. Как думаете, что мне стоило сделать в этой роли? '}
                answers={['Один раз всё рассказать новому сотруднику, передать документы и часть учреждений. А потом спокойно заниматься своей работой, радуясь, что дел поубавилось.', 'Отправить новичка в HR-департамент — пусть там объясняют. Это их работа.', 'Справедливо распределить обязанности, поддерживать новичка, подсказывать, отвечать на вопросы и помогать с адаптацией.']}
                rightAnswer={2}
                resultTitles={['Не совсем так', 'Не совсем так', 'Верно! Я тоже так поступила']}
                resultText={[['Ко мне пришла Ольга Балацкая — молодой менеджер, без опыта в коммерции и дистрибуции. У меня же опыт уже был: я могла подсказывать, отвечать на вопросы. И они меня не раздражали, наоборот, было приятно чувствовать себя гуру.', 'Пока наши взгляды не совпадают, но всё может измениться в атмосфере Р-Фарм.'], ['Ко мне пришла Ольга Балацкая — молодой менеджер, без опыта в коммерции и дистрибуции. У меня же опыт уже был: я могла подсказывать, отвечать на вопросы. И они меня не раздражали, наоборот, было приятно чувствовать себя гуру.', 'Пока наши взгляды не совпадают, но всё может измениться в атмосфере Р-Фарм.'], ['Ко мне пришла Ольга Балацкая — молодой менеджер, без опыта в коммерции и дистрибуции. У меня же опыт уже был: я могла подсказывать, отвечать на вопросы. И они меня не раздражали, наоборот, было приятно чувствовать себя гуру.', 'Наши ответы совпали! И я была бы рада поработать с вами.']]}
                img={'svetlana-test-1'}
                color={'green'}
              />
            </div>
            <div className={`${styles.comment} ${styles.comment_1}`}>
              <Comment name={'Ольга Балацкая'} position={'старший территориальный менеджер'} text={'Со Светланой мне было комфортно работать и развиваться. Я не чувствовала, что она давит или пользуется своим положением. Всю энергию мы тратили на работу, а не на выяснения, кто тут главный.'} img={'svetlana-comment-1'} color={'green'} />
            </div>
            <div className={`${styles.quote} ${styles.quote_2}`}>
              <Quote text={['Наставничество в Р-Фарм — это не про командовать,', 'а про помогать и обучать. Я с этим справилась.', 'И у меня появилось время на новые учреждения.']} textMobile={['Наставничество в Р-Фарм —', ' это не про командовать,', 'а про помогать и обучать.', ' Я с этим справилась.', 'И у меня появилось время', ' на новые учреждения.']} color={'green'} />
            </div>
          </div>
        </section>

        <section data-stage='2' className={`${styles.stage}`}>
          <div className="container">
            <StoryDate date={'2020'} title={'Руководство\nотделом продаж'} color={'green'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_3}`} data-animate={'fade-in-up'}>
              <p>Ещё через два года я стала руководителем отдела продаж по Московской области.</p> <p>Тогда же Р-Фарм нанял ещё одного территориального менеджера, и под моим руководством оказалось уже два сотрудника. Это было непривычно и сложно, сильно вырос уровень ответственности.
              </p>
            </div>
            <div className={`${styles.stars} ${styles.stars_2}`}>
              <Stars number={3} value={2} color={'green'} />
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_4}`} data-animate={'fade-in-up'}>
              <h3>Обучение новичков стало моей проверкой</h3>
              <p>Чтобы обучить сотрудника без опыта требуется около года, потому что направление сложное. И такое обучение стало для меня, как руководителя, проверкой: ведь всегда быстрее сделать что-то самому, чем обучать другого. Но если пойти по этому быстрому, простому пути, то в конце концов так и будешь всё делать сам. А сотрудник ничему не научится.
              </p>
            </div>
            <div className={styles.chat}>
              <div className={styles.chat__inner}>
                <div className={styles.chat__list}>
                  <Message img={'chat-placeholder-pink'} name={'Паша'} position={'менеджер'} text={'Не понимаю, как мне правильно заполнить документы для поставки продукции в областной диспансер... Поможешь?'}  color={'green_transparent'}/>
                  <Message img={'chat-svetlana'} name={'Светлана'} position={'руководитель'} text={'Давай я еще раз объясню, а ты сам попробуешь сделать по моему примеру?'} color={'green'} float={'right'} />
                  <Message img={'chat-placeholder-pink-2'} name={'Паша'} position={'менеджер'} text={'Давай, но, наверное, я буду долго возиться и замучаю тебя вопросами'}  color={'green_transparent'}/>
                  <Message img={'chat-svetlana'} name={'Светлана'} position={'руководитель'} text={'Ничего страшного! Зато научишься'} color={'green'} float={'right'} emoji={['like', 'smile-pink']} />
                </div>
              </div>
            </div>
            <div className={`${styles.quote} ${styles.quote_3}`}>
              <Quote text={['Это был мой первый опыт в роли руководителя.', ' Я многого не умела, но мне помогало то, что я сама', 'когда-то вела эту территорию и знала все', 'учреждения: от самых мелких больниц до Минздрава', 'области.']} textMobile={['Это был мой первый опыт', ' в роли руководителя.', ' Я многого не умела, но мне', ' помогало то, что я сама', 'когда-то вела эту территорию и знала все учреждения:', ' от самых мелких больниц до Минздрава области.']} color={'green'} />
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_5}`} data-animate={'fade-in-up'}>
              <h3>Хоть я и руководитель, я тоже продаю</h3>
              <p>Я знаю, что в некоторых крупных компаниях отделы продаж сталкиваются с проблемой: нет времени на продажи! Всё съедают отчеты, планерки, совещания и снова отчеты. Мы же <span>в Р-Фарм</span> стараемся выдерживать пропорцию и больше времени тратить на встречи и общение с клиентами.
              </p>
            </div>
            <div className={styles.photo} data-animate={'fade-in-up'}>
              <div className={styles.progressbar}>
                <ProgressBar />
              </div>
              <Photo img={'svetlana-photo-4'} align={'right'} desc={'Встреча Светланы с партнером'} />
            </div>
            <div className={`${styles.quote} ${styles.quote_4}`}>
              <Quote text={['Такая пропорция позволила мне даже на должности', ' руководителя отдела не утонуть в организационной', 'работе и заниматься любимым делом — продавать.']} textMobile={['Такая пропорция позволила ', 'мне даже на должности', ' руководителя отдела', ' не утонуть в организационной', 'работе и заниматься любимым', ' делом — продавать.']} color={'green'} />
            </div>

          </div>
        </section>

        <section data-stage='3' className={`${styles.stage} `}>
          <div className="container">
            <StoryDate date={'2022'} title={'Руководство\nдепартаментом'} color={'green'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_6}`} data-animate={'fade-in-up'}>
              <p>Летом 2022 года я стала заместителем директора департамента региональных продаж по Москве и Московской области. Эта должность — еще более ответственная: больше территория — больше вызовов, проблем. Мне предстояло влиться в новую команду и руководить новым составом сотрудников.
              </p>
            </div>
            <div className={`${styles.stars} ${styles.stars_3}`}>
              <Stars number={3} value={3} color={'green'} />
            </div>
            <div className={`${styles.test} ${styles.test_2}`}>
              <Test
                question={'Я не собирала новую команду, а пришла руководить уже сложившейся. Как, на ваш взгляд, мне стоило себя вести в этой ситуации?'}
                answers={['Установить свои правила, чтобы сразу показать, кто здесь главный. Иначе уважения не добиться.', 'Попросить помощи у команды — они здесь давно и лучше знают, как работать эффективно.', 'Подождать! Время покажет, как действовать. Пока плывем по течению.']}
                rightAnswer={1}
                resultTitles={['Нет, это не путь Р-Фарм', 'Мы мыслим похоже!', 'Нет, это не путь Р-Фарм']}
                resultText={[['Команда, в которую я пришла, — довольно опытная и зрелая, так как в Р-Фарм нет текучки. Ребята хорошо приняли мое повышение, а я не стала навязывать свои правила или плыть по течению. Вместо этого сразу попросила помочь мне вникнуть в работу департамента. И они помогли.', 'Пока наши подходы отличаются, но если придете в Р-Фарм, поможем вам адаптироваться.'], ['Команда, в которую я пришла, — довольно опытная и зрелая, так как в Р-Фарм нет текучки. Ребята хорошо приняли мое повышение, а я не стала навязывать свои правила или плыть по течению. Вместо этого сразу попросила помочь мне вникнуть в работу департамента. И они помогли.', 'Мы с вами на одной волне. Буду рада видеть вас в команде Р-Фарм.  '], ['Команда, в которую я пришла — довольно опытная и зрелая, так как в Р-Фарм нет текучки. Ребята хорошо приняли мое повышение, а я не стала навязывать свои правила или плыть по течению. Вместо этого сразу попросила помочь мне вникнуть в работу департамента. И они помогли.', 'Пока наши подходы отличаются, но если придете в Р-Фарм, поможем вам адаптироваться.']]}
                img={'svetlana-test-2'}
                color={'green'}
              />
            </div>
            <div className={`${styles.comment} ${styles.comment_2}`}>
              <Comment name={'Валентина Власова'} position={'территориальный менеджер'} text={'Для нас руководитель — член команды, а не нависающая над нами фигура. Мы всегда можем обменяться мнениями, дать обратную связь и вместе улучшить работу департамента.'} img={'svetlana-comment-2'} color={'green'} />
            </div>
          </div>
          <div className="container">
            <div className={`${stylesText.paragraph} ${styles.paragraph_7}`} data-animate={'fade-in-up'}>
              <h3>Как заместитель директора я справляюсь</h3>
              <p>
                Я получила эту должность летом, а в сентябре директор, ее зовут Екатерина, ушла в отпуск: это стало моей проверкой на профпригодность.
              </p>
              <p>
                Сентябрь — сложный месяц: идут торги, начинается подготовка закупок на новый год. Много звонков, писем и работы. И поводов позвать Екатерину на помощь, прервав ее отпуск.
              </p>
              <p>
                Но я решила: буду звонить только в экстренных случаях, а с остальным попробую разобраться сама. И у меня всё получилось: я справилась и испытала удовольствие от такого погружения.
              </p>
              <p>
                А Екатерина назвала этот отпуск лучшим — за 10 дней она почти не открывала ноутбук.
              </p>
            </div>
          </div>

          <div className={styles.parallax}>
            <div className={styles.parallax__img}>
              <picture>
                <source media="screen and (max-width: 767px)" srcSet={`${path}/img/parallax-bg-mobile.webp`} />
                <img src={`${path}/img/parallax-bg.webp`} alt="" />
              </picture>
            </div>
            <div className={styles.parallax__inner}>
              <Parallax factor={0.2} >
                <img src={`${path}/img/airplane.svg`} alt="" />
              </Parallax>
            </div>
          </div>

          <div className="container">
            <div className={`${styles.quote} ${styles.quote_5}`}>
              <Quote text={['За свой карьерный путь от территориального', 'менеджера до заместителя директора департамента', 'я многому научилась: быстро принимать решения,', 'брать на себя больше ответственности,', 'фокусироваться на важном.']} textMobile={['За свой карьерный путь', ' от территориального', ' менеджера до заместителя ', 'директора департамента', 'я многому научилась: быстро', ' принимать решения,', 'брать на себя больше ', 'ответственности,', 'фокусироваться на важном.']} color={'green'} />
            </div>

          </div>
        </section>

        <div className={styles.final}>
          <div className="container">
            <div className={styles.conclusion}>
              <Conclusion img={'svetalana-img'} use={'svetlana'} text={['Считаю ли я свой карьерный рост быстрым? Нет.\nЯ считаю его поступательным и логичным. ', 'У меня всегда были и результат — выполнение плана продаж,\nи амбиции, желание заявлять о себе. Я транслировала\nруководству, что хочу расти: брала новые задачи и ответственность за себя и того парня, курировала новеньких,\nсмотрела на коллег, училась.', 'Сейчас моя должность мне по размеру: я только в нее погружаюсь, есть куда расти. Но если говорить о масштабных планах, в туманном будущем я мечтаю стать боссом своего босса — коммерческим директором.']}>
                <div className={styles.conclusion__construct}>
                  <Figure color={'green'} styleFigure={{ padding: '0rem 2.19rem' }}>
                    Светлана Иващенко
                  </Figure>
                </div>
                <div className={`${styles.conclusion__construct} ${styles.conclusion__construct_square}`}>
                  <Figure color={'pink'} form={'circle'}>
                  </Figure>
                </div>
              </Conclusion>
            </div>
            <div className={styles.invite} data-animate={'fade-in-up'}>
              <Invite color={'green_light'} title={'Если вы тоже амбициозны,'} desc={'умеете показывать результат и не боитесь некоторой доли хаоса в работе, приходите\nв Р-Фарм.'} />
            </div>
            <div className={styles.more}>
              <MoreStory color={'green'} />
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default StorySvetlana;
